import React from "react";
import { Icon } from "@iconify/react";

const SearchField = ({ text, onChange }) => {
  return (
    <form className="formSearch ms-auto" onSubmit={(e) => e.preventDefault()}>
      <input
        type="text"
        className="form-control"
        value={text}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Search"
      />
      <i>
        <svg
          width="18"
          height="19"
          viewBox="0 0 18 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="8.82491"
            cy="9.32491"
            r="6.74142"
            stroke="#006666"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.5137 14.3638L16.1567 16.9999"
            stroke="#006666"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </i>
    </form>
  );
};

export default SearchField;
